const isBrowser = typeof navigator !== "undefined";

const readUserAgentData = (): { platform?: string; mobile?: boolean } => {
  const uaData = (
    navigator as Navigator & {
      userAgentData?: { platform?: string; mobile?: boolean };
    }
  ).userAgentData;
  return {
    platform: uaData?.platform,
    mobile: uaData?.mobile,
  };
};

const resolveOs = (ua: string, platformHint?: string): string | undefined => {
  const hint = platformHint?.toLowerCase() ?? "";
  if (hint.includes("mac")) return "macOS";
  if (hint.includes("win")) return "Windows";
  if (hint.includes("android")) return "Android";
  if (hint.includes("ios") || hint.includes("iphone") || hint.includes("ipad")) {
    return "iOS";
  }
  if (hint.includes("cros") || hint.includes("chrome os")) return "Chrome OS";
  if (hint.includes("linux")) return "Linux";

  const lower = ua.toLowerCase();
  if (/iphone|ipad|ipod|ios/.test(lower)) return "iOS";
  if (lower.includes("android")) return "Android";
  if (lower.includes("mac os x") || lower.includes("macintosh")) return "macOS";
  if (lower.includes("windows")) return "Windows";
  if (lower.includes("cros")) return "Chrome OS";
  if (lower.includes("linux")) return "Linux";
  return undefined;
};

const resolveBrowser = (ua: string): string | undefined => {
  const lower = ua.toLowerCase();
  if (/edg\/|edga\/|edgios\//.test(lower)) return "Edge";
  if (lower.includes("opr/") || lower.includes("opera")) return "Opera";
  if (lower.includes("chrome/") || lower.includes("crios/")) return "Chrome";
  if (lower.includes("firefox/") || lower.includes("fxios/")) return "Firefox";
  if (lower.includes("safari/") && !lower.includes("chrome")) return "Safari";
  return undefined;
};

export const parseUserAgentDeviceName = (
  userAgent?: string | null,
): { deviceName: string; os?: string; browser?: string; isMobile: boolean } => {
  const ua = userAgent?.trim() ?? "";
  if (!ua) {
    return { deviceName: "Unknown device", isMobile: false };
  }

  const browser = resolveBrowser(ua);
  const os = resolveOs(ua);
  const isMobile = /mobile|iphone|ipad|ipod|android|dart:io/.test(ua.toLowerCase());

  if (browser && os) return { deviceName: `${browser} on ${os}`, os, browser, isMobile };
  if (browser) return { deviceName: browser, os, browser, isMobile };
  if (os) return { deviceName: os, os, browser, isMobile };
  return { deviceName: "Unknown device", os, browser, isMobile };
};

export const getClientDeviceName = (): string => {
  if (!isBrowser) return "Web browser";

  const ua = navigator.userAgent ?? "";
  const { platform, mobile } = readUserAgentData();
  const browser = resolveBrowser(ua);
  const os = resolveOs(ua, platform);

  if (browser && os) return `${browser} on ${os}`;
  if (browser) return mobile ? `${browser} (mobile)` : browser;
  if (os) return os;
  return "Web browser";
};
